/**
 * useTutorAccountRedirect — la route `account` du tuteur : la coquille, sa feuille de profil ouverte.
 *
 * L'ancien « Mon compte » (`MyAccountScreen.js`) est retiré : son contenu est la feuille de profil. La
 * route reste celle des liens qui la visent — le retour de l'inscription Stripe
 * (`redirect_from_stripe_onboarding`, que l'ancien écran ne lisait pas : il montrait le compte, et ses
 * liens Stripe une fois le compte relu) et le repli des paramètres ouverts à froid. Elle relit donc le
 * compte (le tirer-pour-rafraîchir de l'ancienne page), demande la feuille, et rend la place à la
 * coquille : la pile ramène à `menu` s'il est dessous, sinon `menu` remplace la route.
 */
import { useNavigation } from "@react-navigation/native"
import { useEffect } from "react"
import { useDispatch } from "react-redux"

import { apiRequest } from "../../../../../../data/redux/actions/api"
import { authService } from "../../../../../../data/services/authService"
import { requestTutorProfileSheet } from "./tutorProfileSheetRequest"

type StackNavigation = {
    canGoBack: () => boolean
    navigate: (route: string) => void
    replace: (route: string) => void
}

const TUTOR_SHELL_ROUTE = "menu"

export function useTutorAccountRedirect(): void {
    const navigation = useNavigation() as unknown as StackNavigation
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(apiRequest(authService.getUser) as never)
        requestTutorProfileSheet()
        if (navigation.canGoBack()) navigation.navigate(TUTOR_SHELL_ROUTE)
        else navigation.replace(TUTOR_SHELL_ROUTE)
        // Une fois, à l'arrivée : la route ne reste pas affichée.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
}
